/**
 * TaskIcon - Icon representing tasks/todo functionality
 * Checkbox with checkmark icon
 */

import type { IconProps } from './IconTypes';

export function TaskIcon({
  size = 20,
  className = '',
  'aria-label': ariaLabel = 'Task',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-label={ariaLabel}
      role="img"
    >
      {/* Checkbox square */}
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      {/* Checkmark */}
      <polyline points="9 11 12 14 20 6" />
    </svg>
  );
}
